export const LineupDisplayOrder: { [key: string]: number } = {
  Default: 1,
  ProjectedHighLow: 2
};
